//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_GroupMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_GroupMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_GroupMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_GroupMediator, BaseMediator);

module.exports = tbs_controller_GroupMediator